import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboNombreInstalacion`, method: 'GET', body: null, token: token})
}
